<h2 mat-dialog-title>Create staging</h2>
<p class="subtitle">{{ data.subTitle }}</p>
<mat-dialog-content>
  <form [formGroup]="form">
    <app-input-field
      label="Select type"
      formControlName="type"
      type="select"
      [options]="stagingEnvironments"
    ></app-input-field>

    @if (form.controls.type.value === 'new') {
      <app-input-field
        label="WP Admin Username"
        formControlName="wpUsername"
        [errorMessages]="wpErrors['user']"
      ></app-input-field>

      <app-input-field
        label="WP Admin Password "
        type="password"
        autocomplete="new-password"
        formControlName="wpPassword"
        [errorMessages]="wpErrors['password']"
      ></app-input-field>

      <app-input-field
        label="WP Admin Email (optional)"
        formControlName="wpEmail"
        [errorMessages]="wpErrors['email']"
      ></app-input-field>
    }
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" (click)="submit()" [disabled]="form.invalid">Create Staging</button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
